/**
 *   Generated file. Do not edit
 */

import { createEnumConverter } from '@iotize/tap/service/core';
import { createEnumArrayConverter } from '@iotize/tap/service/core';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { ArrayConverter } from '@iotize/tap/client/impl';
import { EnumListConverter } from '@iotize/tap/client/impl';
import { ModbusVariableAddressConverter } from './converters';
import { VariableTypeConverter } from './converters';
import { VariableMetaConverter } from './converters';

export const modbusVariableAddress = new ModbusVariableAddressConverter();

export const variableType = new VariableTypeConverter();

export const variableMeta = new VariableMetaConverter();
